// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2xZJ_","title":"Images45_title__3dOdm","images":"Images45_images__1ESHE"};